/* eslint-disable quotes */
module.exports.BASE = "/";

module.exports.ADMIN_LOGIN = "/admin/login";
module.exports.ADMIN_DASHBOARD = "/admin/dashboard";
module.exports.ADMIN_ADMINS = "/admin/admins";
module.exports.ADMIN_ADMINS_ADD = "/admin/admins/add";
module.exports.ADMIN_CUSTOMERS = "/admin/customers";
module.exports.ADMIN_CUSTOMER_DETAIL = "/admin/customers/detail/:id";
module.exports.ADMIN_POSTS = "/admin/posts";
module.exports.ADMIN_POST_DETAIL = "/admin/posts/detail/:id";
module.exports.ADMIN_TRIP_PLANS_UPCOMING = "/admin/trip-plans/upcoming";
module.exports.ADMIN_TRIP_PLANS_PAST = "/admin/trip-plans/past";
module.exports.ADMIN_TRIP_PLAN_UPCOMING_DETAIL =
  "/admin/trip-plans/upcoming/detail/:id";
module.exports.ADMIN_TRIP_PLANS_PAST_DETAIL =
  "/admin/trip-plans/past/detail/:id";
module.exports.ADMIN_TRANSACTIONS = "/admin/transactions";
module.exports.ADMIN_TRANSACTION_DETAIL = "/admin/transactions/detail/:id";
module.exports.ADMIN_TRANSACTIONS = "/admin/transactions";
(module.exports.ADMIN_REPORT = "/admin/report"),
  (module.exports.ADMIN_SETTING = "/admin/setting"),
  // module.exports.ADMIN_GOOGLE_REPORT = '/admin/report'
  (module.exports.ADMIN_LOGOUT = "/admin/logout");
(module.exports.FETCH_POST_WEB = "/post/:code"),
  (module.exports.APP_STRIPE_ONBOARD = "/app/stripe/onboard");
module.exports.ADMIN_PUSH_NOTIFICATION = "/admin/notifications/push";



// WEBPACK FOOTER //
// ./common/constants/paths/client.js